export default __webpack_public_path__ + "static/mirrorNarcissus-abffa1282db50876dac5d506aa89701e.png";